function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.395 8.202a.6.6 0 10-.79-.904l-5.578 4.88-2.603-2.602a.6.6 0 10-.848.848l3 3a.6.6 0 00.82.027l6-5.25z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 20c5.523 0 10-4.477 10-10s-4.477-10-10-10S.5 4.477.5 10s4.477 10 10 10zm8.8-10a8.8 8.8 0 11-17.6 0 8.8 8.8 0 0117.6 0z",
  fill: "#fff"
});

function SvgCircleCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjM5NTEgOC4yMDE1NUMxNS42NDQ1IDcuOTgzMzQgMTUuNjY5OCA3LjYwNDI4IDE1LjQ1MTUgNy4zNTQ5QzE1LjIzMzMgNy4xMDU1MiAxNC44NTQzIDcuMDgwMjUgMTQuNjA0OSA3LjI5ODQ1TDkuMDI3MzQgMTIuMTc4OEw2LjQyNDI2IDkuNTc1NzRDNi4xODk5NSA5LjM0MTQyIDUuODEwMDUgOS4zNDE0MiA1LjU3NTc0IDkuNTc1NzRDNS4zNDE0MiA5LjgxMDA1IDUuMzQxNDIgMTAuMTg5OSA1LjU3NTc0IDEwLjQyNDNMOC41NzU3NCAxMy40MjQzQzguNzk5MSAxMy42NDc2IDkuMTU3MzggMTMuNjU5NiA5LjM5NTEgMTMuNDUxNUwxNS4zOTUxIDguMjAxNTVaIiBmaWxsPSJ3aGl0ZSIgc3R5bGU9ImZpbGw6d2hpdGU7ZmlsbC1vcGFjaXR5OjE7Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNSAyMEMxNi4wMjI4IDIwIDIwLjUgMTUuNTIyOCAyMC41IDEwQzIwLjUgNC40NzcxNSAxNi4wMjI4IDAgMTAuNSAwQzQuOTc3MTUgMCAwLjUgNC40NzcxNSAwLjUgMTBDMC41IDE1LjUyMjggNC45NzcxNSAyMCAxMC41IDIwWk0xOS4zIDEwQzE5LjMgMTQuODYwMSAxNS4zNjAxIDE4LjggMTAuNSAxOC44QzUuNjM5ODkgMTguOCAxLjcgMTQuODYwMSAxLjcgMTBDMS43IDUuMTM5ODkgNS42Mzk4OSAxLjIgMTAuNSAxLjJDMTUuMzYwMSAxLjIgMTkuMyA1LjEzOTg5IDE5LjMgMTBaIiBmaWxsPSJ3aGl0ZSIgc3R5bGU9ImZpbGw6d2hpdGU7ZmlsbC1vcGFjaXR5OjE7Ii8+Cjwvc3ZnPgo=";
export { SvgCircleCheckWhite as ReactComponent };